<template>
  <div class="illegal">
    <img src="./images/main.png" alt="" />
  </div>
</template>
<script>
export default {
  name: 'Illegal',
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.illegal {
  width: 100%;
  height: 100vh;
  overflow: auto;
  img {
    width: 100%;
    max-width: 100%;
  }
}
</style>
